import { isPassableTerrain } from '@wareena/grid-battles-entity/game/map/terrain';
import { isSamePosition } from '@wareena/game-algorithms';
import { findPathAStar } from '@wareena/game-algorithms';
function getPathToBecomeAdjacentToPosition(agentUnit, movementPoints, targetPosition, hexProperties, rules, allUnits, mapHexes, shouldBeAbleToTravelTheWholePath = true) {
    const { cost: movementCost, path, pathWithCost, } = findPathAStar({
        startPosition: agentUnit.position,
        targetPosition: targetPosition,
        getExistingNeighbours: (position) => {
            const neighbours = rules.getExistingNeighbours(position);
            return neighbours.filter((n) => {
                const isTargetPosition = isSamePosition(targetPosition, n);
                if (!isTargetPosition) {
                    const hex = mapHexes.find((h) => h.column === n.column && h.row === n.row);
                    if (!hex || !isPassableTerrain(hex.terrainId)) {
                        return false;
                    }
                }
                const unitOnPosition = isTargetPosition
                    ? null
                    : allUnits.find((u) => {
                        if (isSamePosition(u.position, n)) {
                            return true;
                        }
                        return false;
                    });
                if (unitOnPosition) {
                    return false;
                }
                return true;
            });
        },
        getMovementCost: (from, to) => {
            const cost = rules.getMovementCost(from, to, agentUnit);
            if (cost === null) {
                return 1_000_000;
            }
            return cost;
        },
        getHeuristicDistance: (from, to) => {
            return hexProperties.getDistance(from, to);
        },
    });
    if (shouldBeAbleToTravelTheWholePath) {
        if (path.length <= 2) {
            return null;
        }
        const lastLegCost = rules.getMovementCost(path[path.length - 2], targetPosition, agentUnit) ?? 0;
        if (movementCost - lastLegCost <= movementPoints) {
            return path.slice(1, path.length - 1).map((p) => ({
                column: p.column,
                row: p.row,
            }));
        }
        return null;
    }
    else {
        if (path.length <= 2) {
            return null;
        }
        const pathToReturn = [];
        pathWithCost.forEach((position) => {
            if (isSamePosition(position, agentUnit.position)) {
                return;
            }
            if (isSamePosition(position, targetPosition)) {
                return;
            }
            if (position.cost <= movementPoints) {
                pathToReturn.push({ row: position.row, column: position.column });
            }
        });
        return pathToReturn;
    }
}
export default getPathToBecomeAdjacentToPosition;
